<template>
  <div class="form-dossier">
    <div class="field col-md-12 mt-4">
      <select
        :value="informationComp.boite"
        @change="handleChangeBoite($event.target.value)"
        id="boite"
        name="boite"
        class="form-select inputsize"
        placeholder=" "
        :disabled="desac"
        :class="{ isNotValid: !checkBoite }"
      >
        <option value="null" disabled>
          Avec quelle type de boite voulez-vous conduire ?
        </option>
        <option value="bm">Boite manuelle</option>
        <option value="ba">Boite Automatique</option>
      </select>

      <label class="labelForm">Choisissez votre type de vehicule ?</label>
    </div>

    <div class="field col-md-12 mt-4">
      <select
        :value="informationComp.forfait"
        @change="handleChangeForfait($event.target.value)"
        id="forfait"
        name="forfait"
        class="form-select inputsize"
        placeholder=" "
        :disabled="desac"
        :class="{ isNotValid: !checkForfait }"
      >
        <option value="null" disabled>Quelle formation envisagez-vous ?</option>
        <option value="code">Code</option>
        <option value="code,conduite">Code et Conduite</option>
        <option value="conduite">Conduite</option>
      </select>

      <label class="labelForm">Quelle formation envisagez-vous ?</label>
    </div>

    <div class="field col-md-12 mt-4">
      <select
        :value="contractValue.code"
        @change="handleChangeAlreadyHasCode($event.target.value)"
        id="code"
        name="code"
        class="form-select inputsize"
        placeholder=" "
        :disabled="desac"
        :class="{ isNotValid: !checkAlreadyHasCode }"
      >
        <option value="null" disabled>Avez-vous eu votre code ?</option>
        <option value="true">OUI</option>
        <option value="false">NON</option>
      </select>

      <label class="labelForm">Avez-vous eu votre code ?</label>
    </div>

    <div class="field col-md-12 mt-4">
      <select
        :value="contractValue.conduite"
        @change="handleChangeContractConduite($event.target.value)"        
        id="conduit"
        name="conduit"
        class="form-select inputsize"
        placeholder=" "
        :disabled="desac"
        :class="{ isNotValid: !checkConduite }"
      >
        <option value="null" disabled>
          Combien d'heures avez-vous conduit en auto-école ?
        </option>
        <option value="0">Entre 0 et 4h</option>
        <option value="1">Entre 5 et 10h</option>
        <option value="3">Entre 11 et 20h</option>
        <option value="3">+20h</option>
      </select>

      <label class="labelForm"
        >Combien d'heures avez-vous conduit en auto-école ?</label
      >
    </div>

    <div class="field col-md-12 mt-4">
      <MultiSelect
        class="mutltiSelect"
        :class="{ isNotValid: !checkInfo }"
        :modelValue="contractValue.selectedContrat"
        @update:modelValue="handleChangeSelectedContrat($event)"                
        :options="knows"
        optionLabel="brand"
        placeholder="Savez-vous"
        :disabled="desac"
      />
    </div>

    <div class="field col-md-12 mt-4">
      <MultiSelect
        class="mutltiSelect"
        :class="{ isNotValid: !checkInfoTwo }"
        :modelValue="contractValue.selectedKnows"
        @update:modelValue="handleChangeSelectedKnows($event)"
        :options="knowsTwo"

        optionLabel="brand"
        placeholder="Savez-vous"
        :disabled="desac"
      />
    </div>

  </div>
  <div class="footer-form">
      <div><p v-if="error" class="errorMsg">{{ error }}</p></div>
      <div class="btnForm">
          <b-button
            @click="cancelStep"
            class="btnForm"
          >
            Retour
          </b-button>

          <b-button
            @click="suivantEtape3"
            class="btnForm"
          >
            Suivant
          </b-button>
      </div>
    </div>
</template>

<script>
import MultiSelect from "primevue/multiselect";

export default {
  name: "FormulairesStep3",
  components: { MultiSelect },
  props: {
    step: Number,
    desac: Boolean,
    error: String,
    informationComp: Object,
    contractValue: Object,
    knows: Array,
    knowsTwo: Array,
    checkBoite: Boolean,
    checkForfait: Boolean,
    checkCode: Boolean,
    checkConduite: Boolean,
    checkInfo: Boolean,
    checkInfoTwo: Boolean,
    suivantEtape3: Function,
    cancelStep: Function,
    handleChangeBoite: Function,
    handleChangeForfait: Function,
    handleChangeAlreadyHasCode: Function,
    handleChangeContractConduite: Function,
    handleChangeSelectedContrat: Function,
    handleChangeSelectedKnows: Function,
    checkAlreadyHasCode: Function


  },
};
</script>

<style scoped>
.field {
  position: relative;
}

.labelForm {
  position: absolute;
  pointer-events: none;
  left: 1.25rem;
  top: 7.75px;
  transition: 0.2s ease all;
  font-size: 15px;
}

.field > select:focus ~ label,
select:not(:placeholder-shown) ~ label {
  top: -15px;
  font-size: 12px;
}

.title {
  font-size: 32px;
}

.isNotValid {
  border-color: red;
}

p.errorMsg,
.footer-form,
.form-dossier {
  max-width: 420px;
}

.mutltiSelect {
  width: 100%;
}

div.btnForm {
  display: flex;
  justify-content: space-between;
}
</style>
